import React, { Component } from "react"
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import IconSVG from "../../utilities/FrontFunctions/IconSVG"
import { urlToHost, dayFrom } from "../../utilities/FrontFunctions/AoxFrontFunctions";
import { equalHeight, ConditionalWrapper } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import ObjCanvasBadgeExpertise from "../inc/ObjCanvasBadgeExpertise"
import { TRAININGNBJOURISNEW } from "../../data/const"

import '../../assets/css/0020_objects/0610_obj_push_card.css'

class ObjPushCardFormation extends Component {
	constructor(props) {
		super(props);
		this.state = {
            datasTraining: this.props.datasTraining,
			typeofPush: this.props.typeofPush,
			newBadge: false,
			badgeItem: {
                Badge_Type: 'coin',
                Badge_Theme: 'gold',
                Badge_Title: 'Intitulé du badge',
                Badge_Description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.',
				collected: true,
			},
		};
		this.canvasIdCoin = `canvas-formation-coin-${Date.now()}-${Math.random()
			.toString(36)
			.slice(2, 10)}`;
	}

	componentDidMount() {
		window.addEventListener('resize', this.throttleWindowResizeCustomSelect);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeCustomSelect);
	}

	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_push_card .ctn_text_card");
		});
	}

  	render() {
		const { typeofPush, datasTraining } = this.state;
        // Vérifiez si vous êtes dans le cas "Player"
        const isPlayerCase = typeofPush === "Player";
        const nbDayFrom = dayFrom(datasTraining?.Training_Date_Available);
        var IsWinning = datasTraining.Training_IsParcoursBadgeCadeau && this.props.display !== "parcours-interne";
        var state = ""
        if(nbDayFrom < 0){
            state = "soon"
        } else if(datasTraining && datasTraining.UserTraining && datasTraining?.UserTraining.UserTraining_Completed && 
            (!datasTraining.Training_IsParcoursBadgeCadeau || datasTraining?.UserTraining?.UserTraining_Score >= 100)){
            state = "done"
        } else if(datasTraining?.UserTraining){
            state = "progress"
        } else if(nbDayFrom < TRAININGNBJOURISNEW) {
            state = "new"
        } else {
            state = "todo"
        }

		return (<> {datasTraining && <>
			<div className={`obj_push_card ${( (this.props.display === "parcours-gagnant" && !IsWinning) ? "is_nonwinning has_description"
                                            : (IsWinning && (state === "new" || state === "todo")) ? 'is-available' 
                                            : (state === "soon") ? 'is-not-available' 
                                            : '')}`}>
                <div className="ctn_media_card">
                    <ConditionalWrapper condition={state !== "soon"} wrapper={children => <a href={urlToHost(datasTraining.Training_WebEventId ? ("/Accueil/Events/EventDetail?id=" + datasTraining.Training_WebEventId) : datasTraining.Training_Url)}>{/* Url relative venant de la DB => doit être absolu*/}{children}</a>}>
                        {isPlayerCase ? (
                            // Affichez cette section si vous êtes dans le cas "Player"
                            <div className="obj_player">
                                <picture className="ctn_player fade-in">
                                    <img src={urlToHost(datasTraining.Training_Image_Url)} alt={datasTraining.Training_Title} />
                                </picture>
                            </div>
                        ) : ( <>
                            <div className="obj_image">
                                <picture className="ctn_image fade-in">
                                    <img src={urlToHost(datasTraining.Training_Image_Url)} alt={datasTraining.Training_Title} />
                                </picture>
                            </div>
                        </> )}

                        {(state === "progress" || state === "done") && (
                            <div className="obj_progress-bar_card">
                                <div className="obj_step-progress-bar" style={{ width: (datasTraining.UserTraining ? datasTraining.UserTraining.PourcentProgress : 0)  + '%' }}></div>
                            </div>
                        )}

                        {this.props.display === "parcours-gagnant" ?
                            <div className="obj_info-right_card">
                                {datasTraining.Training_Duration && 
                                    <div className="obj_info_card">
                                        <div className="obj_picto_card">
                                            <IconSVG icon="clock_outline" />
                                        </div>
                                        <span>{datasTraining.Training_Duration}</span>
                                    </div>
                                }
							</div>
                        : 
                            <div className="obj_info-right_card">
                                {state === "new" && (<>
                                    <div className="obj_info_card var_new">
                                        <span>Nouveau</span>
                                    </div>
                                </>)}
                                {state === "progress" && (
                                    <div className="obj_info_card">
                                        <span>En cours</span>
                                    </div>
                                )}
                                {state === "done" && (
                                    <div className="obj_info_card">
                                        <span>Terminé</span>
                                    </div>
                                )}
                                {state !== "soon" && state !== "done" && datasTraining.Training_Duration && 
                                    <div className="obj_info_card">
                                        <div className="obj_picto_card">
                                            <IconSVG icon="clock_outline" />
                                        </div>
                                        <span>{datasTraining.Training_Duration}</span>
                                    </div>
                                }
                            </div>
                        }
                    </ConditionalWrapper>
                </div>

                <div className="ctn_content_card">
                    <div className="ctn_text_card">
                        <ConditionalWrapper condition={state !== "soon"} wrapper={children => <a href={urlToHost(datasTraining.Training_WebEventId ? ("/Accueil/Events/EventDetail?id=" + datasTraining.Training_WebEventId) : datasTraining.Training_Url)}>{/* Url relative venant de la DB => doit être absolu*/}{children}</a>}>
                            <h3 className="t_title">{datasTraining.Training_Title}</h3>
                            {!IsWinning &&
                                <p className="t_desc">{datasTraining.Training_Subtitle}</p>
                            }
                        </ConditionalWrapper>
                    </div>
                    <div className="ctn_footer_card">
                        <div className="obj_nb-views_card">
                            {state === "soon" ? (
                                <span>&nbsp;</span>
                            ) : (<>
                                <IconSVG icon="eye_outline" />
                                <span>{datasTraining.Training_NbViews || 0} {(datasTraining.Training_NbViews || 0)<2 ? "vue" : "vues"}</span>
                            </>)}
                        </div>
                    </div>
                    <div className="ctn_aside_card">
                        {state !== "soon" && (
                            <button
                                className={`btn_fav-push-formation ${datasTraining.Training_IsFavorite ? 'is_liked' : ''}`}
                                type="button"
                                onClick={() => this.props.handleButtonFav(datasTraining.Training_ItemTraining_Id)}
                            >
                                {datasTraining.Training_IsFavorite === false && (
                                    <IconSVG icon="heart_outline" />
                                )}
                                {datasTraining.Training_IsFavorite === true && (
                                    <IconSVG icon="heart_fill" />
                                )}
                            </button>
                        )}

                        {IsWinning &&
                            <div className={`obj_state_info_card ${(state === "new" || state === "todo") ? 'is_new' : ''} ${state === "done" ? 'is_done' : ''} ${state === "progress" ? 'is_progress' : ''}`}>
                                <div className="ctn_content">
                                    <div className="obj_text">
                                        <div className="ctn_text">
                                            {state === "soon" && (
                                                <>
                                                <p className="t_title">Mon parcours gagnant</p>
                                                <p className="t_desc">Pièce bientôt<br /> disponible</p>
                                                </>
                                            )}
                                            {(state === "new" || state === "todo") && (
                                                <>
                                                <p className="t_title">Mon parcours gagnant</p>
                                                <p className="t_desc">Pièce à collecter !</p>
                                                </>
                                            )}
                                            {state === "progress" && (<>
                                                <p className="t_title">Mon parcours gagnant</p>
                                                <p className="t_desc">Obtenez 100% de réussite pour collecter votre pièce</p>
                                            </>)}
                                            {state === "done" && (<>
                                                <p className="t_title">Mon parcours gagnant</p>
                                                <p className="t_desc">Pièce déjà collectée</p>
                                            </>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="ctn_media">
                                    {state === "soon" && (
                                        <IconSVG icon="piece_or_desactive" />
                                    )}
                                    {(state === "new" || state === "todo") && (
                                        // <IconSVG icon="piece_or_active" />
                                        <ObjCanvasBadgeExpertise
                                            badgeItem={this.state.badgeItem}
                                            newBadge={this.state.newBadge}
                                            canvasId={this.canvasIdCoin}
                                            canvasClass="canvas-formation-coin"
                                        />
                                    )}
                                    {state === "progress" && (
                                        // <IconSVG icon="piece_or_active" />
                                        <ObjCanvasBadgeExpertise
                                            badgeItem={this.state.badgeItem}
                                            newBadge={this.state.newBadge}
                                            canvasId={this.canvasIdCoin}
                                            canvasClass="canvas-formation-coin"
                                        />
                                    )}
                                    {state === "done" && (
                                        <IconSVG icon="piece_or_collectee" />
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjPushCardFormation));